import { render } from "./Alpha.vue?vue&type=template&id=533cbee8"
import script from "./Alpha.vue?vue&type=script&lang=ts"
export * from "./Alpha.vue?vue&type=script&lang=ts"
script.render = render

export default script